import { createContext } from 'react';

const settingContext = createContext({});

export default settingContext;
